"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNextDayPayoutsEnabledMockData = exports.buildPayoutFailedMockData = exports.buildNegativePayoutCreatedMockData = exports.buildPayoutCreatedMockData = exports.buildPayoutPausedMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const CAMPAIGNS_BREAKDOWN = "• Annual Gala: $5,000\n• Monthly Giving: $7,345";
const FUNDS_BREAKDOWN = "• General Fund: $4,891.56\n• Unassigned: $2,876";
const buildPayoutPausedMockData = ({ locale = "en", subject = "Your payouts have been paused", firstName = "John", organizationName = "Bright Futures Foundation", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    organizationName,
});
exports.buildPayoutPausedMockData = buildPayoutPausedMockData;
const buildPayoutCreatedMockData = ({ locale = "en", subject = "Your payout is on its way", firstName = "John", amount = "$12,345.00", account = "Test Bank", payoutId = "po_1PgQ2rB3xKlMn4Op", payoutDetailLink = "https://www.zeffy.com/en-US/o/bank/payouts/transactions?payoutId=po_1PgQ2rB3xKlMn4Op", campaignsBreakdown = CAMPAIGNS_BREAKDOWN, fundsBreakdown = FUNDS_BREAKDOWN, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    amount,
    account,
    payoutId,
    payoutDetailLink,
    campaignsBreakdownList: (0, organization_facing_base_1.embedPlainTextForMock)(campaignsBreakdown),
    fundsBreakdownList: (0, organization_facing_base_1.embedPlainTextForMock)(fundsBreakdown),
});
exports.buildPayoutCreatedMockData = buildPayoutCreatedMockData;
const buildNegativePayoutCreatedMockData = ({ locale = "en", subject = "A withdrawal has been initiated", amount = "-$430.00", ...rest } = {}) => (0, exports.buildPayoutCreatedMockData)({ locale, subject, amount, ...rest });
exports.buildNegativePayoutCreatedMockData = buildNegativePayoutCreatedMockData;
const buildPayoutFailedMockData = ({ locale = "en", subject = "Your payout has failed", firstName = "John", amount = "$1,250.00", payoutId = "po_1PgQ2rB3xKlMn4Op", failureCode = "account_closed", failureMessage = "The bank account has been closed.", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    amount,
    payoutId,
    failureCode,
    failureMessage,
});
exports.buildPayoutFailedMockData = buildPayoutFailedMockData;
const buildNextDayPayoutsEnabledMockData = ({ locale = "en", subject = "Next-day payouts are now enabled for your organization! 🎉", firstName = "John", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
});
exports.buildNextDayPayoutsEnabledMockData = buildNextDayPayoutsEnabledMockData;
